const btn = document.getElementById('navBtn');
const navlist = document.getElementById('navList');
const header = document.querySelector('.header');

if (btn && header) {
  btn.addEventListener('click', () => {
    header.classList.toggle('nav-open');
    checkHeaderTheme();
  });
}

if (navlist && header) {
  navlist.addEventListener('click', () => {
    header.classList.remove('nav-open');
    checkHeaderTheme();
  });
}

function checkHeaderTheme() {
  if (!header) return;

  const rect = header.getBoundingClientRect();
  const checkX = window.innerWidth / 2;
  const checkY = rect.bottom - 1;

  const elements = document.elementsFromPoint(checkX, checkY);
  if (!elements || !elements.length) return;

  // header 自身を除外して、背面の要素を探す
  const target = elements.find((el) => !el.closest('.header'));

  if (!target) return;

  if (target.closest('.is-dark')) {
    header.classList.add('is-white');
  } else {
    header.classList.remove('is-white');
  }
}

let ticking = false;

function onScrollOrResize() {
  if (ticking) return;

  ticking = true;
  requestAnimationFrame(() => {
    checkHeaderTheme();
    ticking = false;
  });
}

window.addEventListener('scroll', onScrollOrResize);
window.addEventListener('resize', onScrollOrResize);
window.addEventListener('load', checkHeaderTheme);